import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import {
    SectionHeader,
    TrueFalseRadio,
} from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";

interface IThirdPartyOptionsProps extends React.Props<ThirdPartyOptions> {
    isReview?: boolean;
    data: FirmInstruction;
    onChange: (changes) => void;
    onRef: (ref) => void;
}

interface IThirdPartyOptionsState {}

export class ThirdPartyOptions extends FormComponent<IThirdPartyOptionsProps, IThirdPartyOptionsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { data, isReview } = this.props;
        return (
            <>
                {SectionHeader("Adviser Remuneration available")}
                <CheckboxGroup
                    type="block"
                    options={[
                        {
                            label: "Allow adviser remuneration",
                            value: data.AllowAdviserRemuneration,
                            disabled: isReview,
                            onChange: (v) => this.props.onChange({ AllowAdviserRemuneration: v }),
                        },
                    ]}
                />
                <hr />
                {SectionHeader("Tax Exemption")}
                <CheckboxGroup
                    type="block"
                    options={[
                        {
                            label: "Is third party firm Tax Exempt?",
                            value: data.TaxExempt,
                            disabled: isReview,
                            onChange: (v) => this.props.onChange({ TaxExempt: v }),
                        },
                    ]}
                />
                <hr />
                {SectionHeader("Switch")}
                {TrueFalseRadio(
                    "Allow customers access to switch screens for 3rd party products?",
                    "AllowSwitch",
                    data,
                    (k, v) => this.props.onChange({ [k]: v })
                )}
                <hr />
            </>
        );
    }
}
